import { render, staticRenderFns } from "./RevenueByCustomerPage.vue?vue&type=template&id=0dd927dd&scoped=true"
import script from "./RevenueByCustomerPage.vue?vue&type=script&lang=js"
export * from "./RevenueByCustomerPage.vue?vue&type=script&lang=js"
import style0 from "./RevenueByCustomerPage.vue?vue&type=style&index=0&id=0dd927dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd927dd",
  null
  
)

export default component.exports